import script from "./RitttzyFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./RitttzyFooter.vue?vue&type=script&setup=true&lang=ts"

import "./RitttzyFooter.vue?vue&type=style&index=0&id=d114f0ce&lang=scss"

const __exports__ = script;

export default __exports__